@if (showSkeleton()) {
  <app-form-skeleton/>
} @else {
<div class="container">
  <form (ngSubmit)="onSubmit()" [formGroup]="form">
    <div class="col-12 mb-3 d-flex flex-column align-items-center">
      <ng-container *ngIf="photoThumb(); else placeholder">
        <img
          [src]="photoThumb()"
          alt="avatar"
          width="128"
          height="128"
          class="rounded-circle object-fit-cover border"
        />
      </ng-container>

      <ng-template #placeholder>
        <i class="ri-user-line display-1 text-secondary"></i>
      </ng-template>

      <div class="mt-2 d-flex gap-2">
        <label class="btn btn-outline-primary position-relative overflow-hidden">
          <i class="ri-upload-2-line me-1"></i>{{ 'USER.CHANGE_AVATAR' | translate }}
          <input
            type="file"
            accept="image/*"
            (change)="onPhotoSelected($event)"
            class="position-absolute top-0 start-0 w-100 h-100 opacity-0"
          />
        </label>

        <button
          type="button"
          style="height: 2.75rem"
          class="btn btn-outline-danger"
          (click)="deletePhoto()"
          *ngIf="photoThumb()"
        >
          <i class="ri-delete-bin-line me-1"></i>{{ 'DELETE' | translate }}
        </button>

        <span *ngIf="uploadingPhoto()" class="spinner-border spinner-border-sm"></span>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6 mb-2">
        <input class="form-control" inputValidator label="USERS.FIRSTNAME" formControlName="firstName">
      </div>
      <div class="col-md-6 mb-2">
        <input class="form-control" inputValidator label="USERS.LASTNAME" formControlName="lastName">
      </div>
      @if(!profile) {
        <div class="col-md-6 mb-2">
          <ng-select
            label="USERS.ROLE"
            inputValidator
            [clearable]="false"
            [items]="roles"
            [searchable]="false"
            formControlName="roleId"
          >
            <ng-template let-item="item" ng-label-tmp>
              @if (item) {
                {{ RoleIdLabels[item] | translate }}
              }
            </ng-template>
            <ng-template let-item="item" ng-option-tmp>
              @if (item) {
                {{ RoleIdLabels[item] | translate }}
              }
            </ng-template>
          </ng-select>
        </div>
        <div class="col-md-{{RoleService.currentRole === Roles.ADMIN ? 6 : 12 }} mb-2">
          <autocomplete
            [clearable]="false"
            [url]="getCompanies.bind(this)"
            [parentControl]="form.get('roleId')"
            formControlName="companyId"
            bindLabel="companyName"
            searchKey="search"
            inputValidator
            label="RESIDENTS.COMPANY_NAME"
          />
        </div>
      }
      <div class="col-md-6 mb-2">
        <input class="form-control" inputValidator label="USERS.USERNAME" formControlName="userName">
      </div>
      <div class="col-md-6 mb-2">
        <input class="form-control" inputValidator label="USERS.EMAIL" formControlName="email">
      </div>
      <div class="col-md-6 mb-2">
        <input class="form-control" inputValidator label="USERS.PHONENUMBER" formControlName="phoneNumber">
      </div>
      @if (!this.profile) {
        @if(!isEdit) {
          <div class="col-md-6 password mb-2">
            <p-password
              formControlName="password"
              inputValidator
              label="USERS.PASSWORD"
              [toggleMask]="true"
              [feedback]="false"
              inputStyleClass="form-control"
              styleClass="w-100"
              autocomplete="new-password"
            ></p-password>

          </div>
        }
        <div class="col-md-12 mb-2">
          <div class="form-check form-switch my-2 d-flex align-items-center gap-2">
            <input class="form-check-input" formControlName="status" role="switch" type="checkbox">
            <label class="form-check-label fs-5">{{ 'USERS.STATUS' | translate }}</label>
          </div>
        </div>
      }
    </div>
    <div class="text-end d-flex gap-2 justify-content-end mt-3">
      <p-button
        [disabled]="form.invalid || isPending()"
        styleClass="btn btn-primary d-flex"
        type="submit"
        [loading]="isPending()"
        [label]="'SAVE' | translate"
      >
      </p-button>
    </div>
  </form>
</div>
}
